module.exports = __webpack_public_path__ + "img/hero.1bb14944.png";